module.exports = __webpack_public_path__ + "static/media/newbooth.b2e57f8a.svg";